import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './Client.scss';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css'; 
import 'slick-carousel/slick/slick-theme.css';
import serviceicon from "../../assets/logo/sec-title-icon.jpg";
import service1 from "../../assets/Client/c-1.jpg";
import service2 from "../../assets/Client/c-2.jpg";
import service3 from "../../assets/Client/c-3.jpg";
import service4 from "../../assets/Client/c-4.jpg";
import service5 from "../../assets/Client/c-5.jpg";
import service6 from "../../assets/Client/c-6.jpg";
import service7 from "../../assets/Client/c-7.jpg";
import service8 from "../../assets/Client/c-8.jpg";
import service9 from "../../assets/Client/c-9.jpg";
import { hover } from '@testing-library/user-event/dist/hover';

//import "../Home/Category/Category.scss";
const Client = () => {
  const images = [service1,service2,service3,service4,service5,service6,service7,service8,service9];
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  };

  return (
<div>
        <div className="service_title1">
            <div className="service_title">
                <img src={serviceicon} alt=''/>
                <h5 style={{textTransform:'capitalize'}}>Our Prestigious Client</h5>
                <h1>Our Client</h1>
            </div>
        </div> 
    <div style={{ maxWidth: '1200px', margin: '30px auto' }}>
      <Slider {...settings}>
        {images.map((img, index) => (
          <div className='clientlogo' key={index} style={{ padding: '0 0px'}} >
            <img className='clientlogocaro' src={img} alt={`Slide ${index + 1}`}/>
          </div>
        ))} 
      </Slider>
    </div>
</div>
  );
};
export default Client;